// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import VueResource from 'vue-resource'

// ElementUI
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// import directive from 'element-ui/packages/popover/src/directive';
// Vue.directive('popover', directive);

import App from './App'
import router from './router'
Vue.use(VueResource)

// jquery
import $ from 'jquery'
window.$ = $
window.jQuery = $
    // moment
window.moment = require('moment')

import 'animate.css/animate.min.css'

import './common/stylus/main.styl'

import 'fetch-polyfill'

import md5 from 'js-md5'
// Vue.use(fetch)
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false

Vue.prototype.Storage = {
    set: function(key, data) {
        return window.localStorage.setItem(key, window.JSON.stringify(
            data));
    },
    get: function(key) {
        return window.JSON.parse(window.localStorage.getItem(key));
    },
    remove: function(key) {
        return window.localStorage.removeItem(key);
    }
}

Vue.prototype.ListByIdCache = {
    listByIdsCache:{},
    check: function(id) {
        // 要请求的id数组
        let cache = {}
        let newId = []
        for(let i =0;i<id.length;i++){
            if(this.listByIdsCache[id[i]]){
                cache[id[i]] = this.listByIdsCache[id[i]];
            }else{
                if(id[i].length > 2 && id[i].substring(0,2) != '73'){
                    newId.push(id[i])
                }
            }
        }
        return {cache:cache,newId:newId}
    },
    cacheIdData: function(data) {
        for(var id in data) {
            this.listByIdsCache[id] = data[id];
        }
        // console.log('缓存池中的数据 ===> ' + JSON.stringify(this.listByIdsCache))
    },
    Method: function(url, headers, params){       
    },
}

Vue.prototype.AJAX = {
    get: function(url, headers, params) {
        // 判断网络的链接情况
        if(!window.navigator.onLine){
            console.log('网络异常')
            return new Promise((resolve, reject) => {
                fetch(url, {
                    method: 'GET',
                    headers: headers,
                }).then((response) => {
                    reject({
                        msg: '网络异常，请检查网络'
                    })
                }).then((response) => {   
                    reject({
                        msg: '网络异常，请检查网络'
                    })    
                }).catch((err) => {
                    reject({
                        msg: '网络异常，请检查网络'
                    })
                })
            })
        }
        if (params) {
            let paramsArray = [];
            //encodeURIComponent
            Object.keys(params).forEach(key => paramsArray.push(key +
                '=' + params[key]))

            if (url.search(/\?/) === -1) {
                url += '?' + paramsArray.join('&')
            } else {
                url += '&' + paramsArray.join('&')
            }
        }

        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'GET',
                headers: headers,
            }).then((response) => {

                if (response.ok) {

                    return response.json()

                } else {

                    return {
                        code: response.status
                    };

                }


            }).then((response) => {   
                if (response.code == 0 || response.code == 10000) {
                    // 正常
                    resolve(response)
                } else if (response.code == 20001) {
                    // 用户需要登录
                    reject({
                        msg: response.msg?response.msg: response.message
                    })
                    let location_url = window.location.href
                    if (location_url.indexOf('qt') > 0) {} else {
                        setTimeout(() => {
                            localStorage.setItem(
                                'tab_core',
                                '')
                            location = '/login'//process.env.HOST
                        }, 1000)
                    }
                } else if (response.code == 20010) {
                    // 其他设备登录
                    let location_url = window.location.href
                    if (location_url.indexOf('qt') > 0) {} else {
                        setTimeout(() => {
                            localStorage.setItem(
                                'tab_core',
                                '')
                            location = '/login'
                        }, 1000)
                    }
                    reject({
                        msg: response.msg?response.msg: response.message
                    })
                } else if (response.code == 20007 || response.code ==  220102) {
                    // token无效
                    let location_url = window.location.href
                    if (location_url.indexOf('qt') > 0) {} else {
                        setTimeout(() => {
                            localStorage.setItem(
                                'tab_core',
                                '')
                            location = '/login'//process.env.HOST
                        }, 1000)
                    }
                    reject({
                        msg: response.msg?response.msg: response.message
                    })
                } else {
                    resolve(response)
                }
            }).catch((err) => {
                console.log('xxxxxxxx ====> ' + JSON.stringify(err))
                reject({
                    msg: '网络异常，请检查网络'
                })
            })
        })
    },
    post: function(url, headers, params) {
         // 判断网络的链接情况
         if(!window.navigator.onLine){
            console.log('网络异常')
            return new Promise((resolve, reject) => {
                fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: params,
                }).then((response) => {
                    reject({
                        msg: '网络异常，请检查网络'
                    })
                }).then((response) => {   
                    reject({
                        msg: '网络异常，请检查网络'
                    })    
                }).catch((err) => {
                    reject({
                        msg: '网络异常，请检查网络'
                    })
                })
            })
        }

        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST',
                headers: headers,
                body: params,
            }).then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    return {
                        code: response.status
                    };
                }
            }).then((response) => {
                if (response.code == 0 || response.code == 10000) {
                    // 正常
                    resolve(response)
                } else if (response.code == 20001 || response.code ==  220102) {
                    let location_url = window.location.href
                    if (location_url.indexOf('qt') > 0) {} else {
                        setTimeout(() => {
                            localStorage.removeItem(
                                'editor_url'
                            )
                            localStorage.removeItem(
                                'login_status'
                            )
                            localStorage.removeItem(
                                'tabs')
                            localStorage.removeItem(
                                'tab_type')
                            localStorage.removeItem(
                                'tabs_current_id'
                            )
                            localStorage.removeItem(
                                'tabs_info'
                            )
                            localStorage.removeItem(
                                'team_info'
                            )
                            localStorage.removeItem(
                                'userinfo')
                            location = '/login'//process.env.HOST
                        }, 1000)
                    }
                    reject({
                        msg: response.msg?response.msg: response.message?response.msg:response.message
                    })
                } else if (response.code == 20010) {
                    // 其他设备登录
                    let location_url = window.location.href
                    if (location_url.indexOf('qt') > 0) {} else {
                        setTimeout(() => {
                            localStorage.removeItem(
                                'editor_url'
                            )
                            localStorage.removeItem(
                                'login_status'
                            )
                            localStorage.removeItem(
                                'tabs')
                            localStorage.removeItem(
                                'tab_type')
                            localStorage.removeItem(
                                'tabs_current_id'
                            )
                            localStorage.removeItem(
                                'tabs_info'
                            )
                            localStorage.removeItem(
                                'team_info'
                            )
                            localStorage.removeItem(
                                'userinfo')
                            location = '/login'
                        }, 1000)
                    }
                    reject({
                        msg: response.msg?response.msg: response.message?response.msg:response.message
                    })
                }else if(response.code == 220104){
                    EUY.RemoveStorage('share')
                    EUY.RemoveStorage('editor_url')
                    EUY.RemoveStorage('login_status')
                    EUY.RemoveStorage('tabs')
                    EUY.RemoveStorage('currentTab')
                    EUY.RemoveStorage('team_info')
                    EUY.RemoveStorage('userinfo')
                    EUY.RemoveStorage('login_account')
                    location = '/login';
                    reject({
                        code:response.code,
                        msg: response.msg?response.msg: response.message?response.msg:response.message
                    })
                } else if(response.hash == response.key){
                    // 处理七牛上传返回的结果
                    resolve(response)
                }
                else {
                    console.log('sssssss ===> ' + JSON.stringify(response))
                    reject({
                        code:response.code,
                        msg: response.msg?response.msg: response.message?response.msg:response.message
                    })
                }
            }).catch((err) => {
                console.log('dddddd ====>' + JSON.stringify(err))
                reject({
                    code:err.code,
                    msg: '网络异常，请检查网络'
                })
            })
        })
    },
    delete: function(url, headers, params) {
        // 判断网络的链接情况
        if(!window.navigator.onLine){
            console.log('网络异常')
            return new Promise((resolve, reject) => {
                reject({
                    msg: '网络异常，请检查网络'
                })
            })
        }

        if (params) {
            let paramsArray = [];
            Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
            if (url.search(/\?/) === -1) {
                url += '?' + paramsArray.join('&')
            } else {
                url += '&' + paramsArray.join('&')
            }
        }

        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'DELETE',
                headers: headers,
            }).then((response) => {
                if (response.ok) {
                    return response.json()
                } else {
                    return {
                        code: response.status
                    };
                }
            }).then((response) => {
                if (response.code == 0 || response.code == 10000) {
                    resolve(response)
                } else if (response.code == 20001 || response.code == 220102) {
                    let location_url = window.location.href
                    if (location_url.indexOf('qt') > 0) {} else {
                        setTimeout(() => {
                            localStorage.removeItem('editor_url')
                            localStorage.removeItem('login_status')
                            localStorage.removeItem('tabs')
                            localStorage.removeItem('tab_type')
                            localStorage.removeItem('tabs_current_id')
                            localStorage.removeItem('tabs_info')
                            localStorage.removeItem('team_info')
                            localStorage.removeItem('userinfo')
                            location = '/login'
                        }, 1000)
                    }
                    reject({
                        msg: response.msg ? response.msg : response.message
                    })
                } else if (response.code == 20010) {
                    let location_url = window.location.href
                    if (location_url.indexOf('qt') > 0) {} else {
                        setTimeout(() => {
                            localStorage.removeItem('editor_url')
                            localStorage.removeItem('login_status')
                            localStorage.removeItem('tabs')
                            localStorage.removeItem('tab_type')
                            localStorage.removeItem('tabs_current_id')
                            localStorage.removeItem('tabs_info')
                            localStorage.removeItem('team_info')
                            localStorage.removeItem('userinfo')
                            location = '/login'
                        }, 1000)
                    }
                    reject({
                        msg: response.msg ? response.msg : response.message
                    })
                } else {
                    reject({
                        code: response.code,
                        msg: response.msg ? response.msg : response.message
                    })
                }
            }).catch((err) => {
                console.log('DELETE请求异常 ====>' + JSON.stringify(err))
                reject({
                    msg: '网络异常，请检查网络'
                })
            })
        })
    }
}

// 创建 store 实例
const store = new Vuex.Store({
    state: {
      teamId: ''
    },
    mutations: {
      SET_TEAM_ID(state, teamId) {
        state.teamId = teamId
      }
    },
    actions: {
      updateTeamId({ commit }, teamId) {
        console.log('updateTeamId ====>' + teamId)
        commit('SET_TEAM_ID', teamId)
      }
    },
    getters: {
      currentTeamId: state => state.teamId
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,  // 注入 store
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js